import styled from 'styled-components'

export const FundingSearchStyled = styled.div`
  .gui-mantine-rtl-GateMultiSelect-values,
  .mantine-GateMultiSelect-values {
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;

    .gui-mantine-rtl-GateMultiSelect-value,
    .mantine-GateMultiSelect-value {
      min-width: fit-content;
    }
  }
`
